import { render, staticRenderFns } from "./PublicViewClub.vue?vue&type=template&id=2b83e34e&"
import script from "./PublicViewClub.vue?vue&type=script&lang=ts&"
export * from "./PublicViewClub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports